import { render, staticRenderFns } from "./NotificationsDropDown.vue?vue&type=template&id=08491f16&"
import script from "./NotificationsDropDown.vue?vue&type=script&lang=js&"
export * from "./NotificationsDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports